import React from 'react'
import { TWStaticAFLCard } from './TWStaticAFLCard'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const TWStaticAFLCardRegistration = createRegisterableComponent('tw-static-alf-card', () => (
    <TWStaticAFLCard />
))
